module.exports = __webpack_public_path__ + "static/media/Guts – 1.ad218616.jpg";